import React from "react"
import style from "./List.module.scss"
import { miles } from "../data/miles"
import { BarListItemComponent } from "./BarListItem"
import { bars } from "../data/bars"

export const ListComponent: React.FC = () => {
  const barsCount = miles.reduce((acc, mile) => {
    if (!mile.done) return acc
    // const barsVisited = mile.bars.filter((marker) => marker.image != "denied")
    // return acc + barsVisited.length
    return acc + mile.bars.length
  }, 0)

  return (
    <div className={style.listComponent}>
      <div className={style.lists}>
        {miles.map((mile, index) => {
          return (
            <div className={style.list} key={index}>
              <div className={style.listHeader}>
                <h2>{mile.title}</h2>
                <div>{mile.date}</div>
                <div>Участников: {mile.diggers.length}</div>
                {mile.paths && (
                  <div>
                    {mile.done ? (
                      <div className={style.done}>Завершена</div>
                    ) : (
                      <div className={style.process}>Планируется</div>
                    )}
                  </div>
                )}
                {!mile.paths && <div className={style.spacer} />}
                <br />
              </div>
              {mile.bars.map((barId, index2) => {
                const barToRender = bars.find((bar) => bar.id === barId)
                if (!barToRender) return <></>
                return (
                  <BarListItemComponent
                    key={index2}
                    bar={barToRender}
                    image={mile.image}
                  />
                )
              })}
            </div>
          )
        })}
      </div>
      <div className={style.barsCount}>Пройдено баров: {barsCount}</div>
    </div>
  )
}
